const Joi = require("joi");

const allowedMimeTypes = [
  "image/jpeg", // .jpg, .jpeg
  "image/png", // .png
  "image/gif", // .gif
  "image/webp", // .webp
  "image/bmp", // .bmp
  "image/tiff", // .tif, .tiff
  "image/svg+xml", // .svg
];

const MenuPageIntegrationSchema = (data) => {
  const schema = Joi.object({
    title: Joi.string().trim().required().messages({
      "string.empty": "Please enter Title.",
      "any.required": "Please enter Title.",
    }),
    fileCheck: Joi.alternatives()
      .try(
        // ✅ Case 1: String path from API, must end with valid image extension
        Joi.string().pattern(/\.(jpg|jpeg|png|gif|webp|bmp|tiff|svg)$/i),

        // ✅ Case 2: File-like object
        Joi.object({
          name: Joi.string().required(),
          type: Joi.string()
            .valid(...allowedMimeTypes)
            .required(),
        })
      )
      .required()
      .optional() // 👈 Now it only validates if present
      .messages({
        "any.required": "Please select a file.",
        "string.pattern.base": "Invalid image file path.",
      }),
    descriptionOne: Joi.string()
      .trim()
      .min(1)
      .custom((value, helpers) => {
        // Remove all HTML tags to check for text
        const strippedContent = value
          .replace(/<\/?[^>]+(>|$)/g, "")
          .replace(/&nbsp;/g, "")
          .replace(/\s+/g, "")
          .trim();

        // ✅ Check if stripped text is empty AND also no <img> tag exists
        const hasImage = /<img\s+[^>]*src=["'][^"']+["'][^>]*>/i.test(value);

        if ((!strippedContent || strippedContent.length === 0) && !hasImage) {
          return helpers.message("Please enter Description.");
        }

        return value;
      })
      .required()
      .messages({
        "string.empty": "Please enter Description.",
        "any.required": "Please enter Description.",
        "string.min": "Please enter Description.",
      }),

    // descriptionTwo: Joi.string()
    //   .trim()
    //   .min(1)
    //   .custom((value, helpers) => {
    //     const strippedContent = value
    //       .replace(/<\/?[^>]+(>|$)/g, "")
    //       .replace(/&nbsp;/g, "")
    //       .replace(/\s+/g, "")
    //       .trim();

    //     if (!strippedContent || strippedContent.length === 0) {
    //       return helpers.message("Please enter Description.");
    //     }

    //     return value;
    //   })
    //   .required()
    //   .messages({
    //     "string.empty": "Please enter Description.",
    //     "any.required": "Please enter Description.",
    //     "string.min": "Please enter Description.",
    //   }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = MenuPageIntegrationSchema;
